// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue                  from 'vue'
import App                  from './App'
import VueRouter            from "vue-router"
import router               from './router'
import axios                from 'axios'
import VueTheMask           from 'vue-the-mask'
import VueMoney             from 'v-money'
import mobile               from 'mobile-device-detect';
import Autocomplete         from '@trevoreyre/autocomplete-vue'
// import FloatingVue from 'floating-vue'
import '@trevoreyre/autocomplete-vue/dist/style.css'
// import 'floating-vue/dist/style.css'

var url                     = "https://plataforma.hidrobombas.com.br";
Vue.use(VueRouter)
// Vue.use(FloatingVue)
// Vue.use(FloatingVue)
Vue.use(VueTheMask)
Vue.use(VueMoney)
Vue.use(mobile)
Vue.use(Autocomplete)

window.axios                = axios
axios.defaults.baseURL      = url;
Vue.config.productionTip    = false
window._app;
Vue.config.ignoredElements = [/^ion-/]
if (!window.cordova && location.hostname != "localhost") {
    window.console.log      = function(){};
}
// if (window.cordova || location.hostname != "localhost") {
    axios.defaults.timeout  = 60000;
// }

/* eslint-disable no-new */
new Vue({
  	el:                  '#app',
  	router,
  	components: {
        App
    },
  	template:            '<App/>',

    data: {
        "logged":       false,
        "cordova":      window.cordova || null,
        "user":  {
            "cod":      null,
            "token":    null,
            "tipo":     null
        },
        "mobile":       mobile,
        "tmp":  {
        },
        "modal": {
        },
        "config": {
            "url":      url,
            "googleAnalytics": {
                "id":   ""
            },
            "pagarme": {
                "key": "pk_test_LNW4b57hOHYGA7xX"
            },
            "pusher": {
                "key": "670cf71549d1536ad6a9"
            },            
            "money": {
                "decimal":            ',',
                "thousands":          '.',
                "prefix":             '',
                "suffix":             '',
                "precision":          2,
                "masked":             false
            },      
            "mapa": {
                "style": [
                  {
                    "featureType": "administrative",
                    "elementType": "geometry",
                    "stylers": [
                      {
                        "visibility": "off"
                      }
                    ]
                  },
                  {
                    "featureType": "poi",
                    "stylers": [
                      {
                        "visibility": "off"
                      }
                    ]
                  },
                  {
                    "featureType": "road",
                    "elementType": "labels.icon",
                    "stylers": [
                      {
                        "visibility": "off"
                      }
                    ]
                  },
                  {
                    "featureType": "transit",
                    "stylers": [
                      {
                        "visibility": "off"
                      }
                    ]
                  }
                ],              
                "zoom": 17
            },
        },
        "confirmacaoSair": false,
        "sidebarToggleStatus": (window.localStorage.getItem("sidebarToggleStatus") == "true" ? true : false),
    },
    methods: {
        sidebarToggle: function() {
            var self = this;
            console.log("sidebarToggle()", self.sidebarToggleStatus)
            if (self.sidebarToggleStatus) {
                self.sidebarToggleStatus = false;
                // $("body").removeClass("sidebar-closed");
            } else {
                self.sidebarToggleStatus = true;
                // $("body").addClass("sidebar-closed");
            }

            // window.localStorage.setItem("sidebarToggleStatus", self.sidebarToggleStatus);
            self.$forceUpdate();
        },
        changeSidebarToggle: function() {
            var self = this;
            console.log("changeSidebarToggle()", self.sidebarToggleStatus)
            if (!self.sidebarToggleStatus) {
                $("html").removeClass("sidebar-closed");
            } else {
                $("html").addClass("sidebar-closed");
            }

            window.localStorage.setItem("sidebarToggleStatus", self.sidebarToggleStatus);
            self.$forceUpdate();            
        },
        initialize: function() {
            console.log("app.initialize()");
            var self             = this;

            // gtag('js', new Date());
            // gtag('config', self.config.googleAnalytics.id);

            self.sidebarToggleStatus = (window.localStorage.getItem("sidebarToggleStatus") == "true" ? true : false);
            console.log("INICIAL", self.sidebarToggleStatus)
            self.changeSidebarToggle();

            if (window.localStorage.getItem("_config")) {
                var cfg = JSON.parse(window.localStorage.getItem("_config"));
                
                self.config["configuracoes"] = cfg; 
                self.$forceUpdate();
            }

            window.confirmWeb   = window.confirm;
            window.confirm      = function(msg, callback) {
                if (window.confirmWeb(msg)) {
                    callback();
                }
            }

            var self        = this;
            window.__app    = self;
            var login       = self.checkLogin();
            self.fixClass();   
            self.getConfig();

        },
        scrollTop: function() {
            setTimeout(function() {
                $(".dashboard-content-inner")[0].scrollTo({
                    top:    0
                });     
            }, 100);
        },         
        go: function(route, data) {
            console.log("app.go()", route, data)
            var self = this;
            if (!data) {
                data = {};
            } else {
                data = JSON.parse(data);
                console.log("fez parse", data);
            }
            self.$router.push({ 
                name:       route,
                query:      data
            }).catch(()=>{});               
            $("body .overhang").fadeOut(500);
        },
        redirect: function(route) {
            console.log("app.redirect()", route)
            var self = this;
            self.$router.push({ 
                path:       route
            }).catch(()=>{});               
            $("body .overhang").fadeOut(500);
        },         
        sequence: function(tasks, fn) {
            console.log("sequence()", tasks, fn)
            return tasks.reduce((promise, task) => promise.then(() => fn(task)), Promise.resolve());
        },              
        setUser: function(usuario) {
            var self    = this;
            return new Promise(function(resolve, reject) {
                window.localStorage.setItem("_usuario", JSON.stringify(usuario));
                self.logged    = true;
                self.user   = usuario;

                resolve(usuario);

            });
        },
        getConfig: function(force) {
            var self        = this;
            console.log("getConfig()");
            return new Promise(function(resolve, reject) {

                var form = {
                    "params": {
                        "_cod":         self.user.cod, 
                        "_token":       self.user.token
                    }
                };

                axios.get("api/configuracoes.php", form)
                .then(response => {
                    
                    console.log("getConfig() response", response);

                    window.localStorage.setItem("_config", JSON.stringify(response.data.result));

                    self.config["configuracoes"] = response.data.result;
                    self.$forceUpdate(); 
                    resolve(response.data.result);

                })
                .catch(error => {
                    console.log("getConfig() error", error);
                    reject(error);
                    
                });   
            });   
        },           
        getUser: function(force) {
            var self        = this;
            console.log("getUser()");
            return new Promise(function(resolve, reject) {

                var form = {
                    "params": {
                        "_cod":         self.user.cod, 
                        "_token":       self.user.token
                    }
                };

                axios.get("api/usuarios.php", form)
                .then(response => {
                    
                    console.log("getUser() response", response);
                    self.setUser(response.data.result);

                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("getUser() error", error);
                    if (error.response) {
                        if (error.response.status == 404) {
                            self.logout();
                        }
                    }
                    
                    reject(error);
                    
                });   
            });   
        },                           
        checkLogin: function() {
            var self    = this;
            if (!window.localStorage.getItem("_usuario")) {
                return false;
            } else {
                var usuario = null;
                try {
                    usuario = JSON.parse(window.localStorage.getItem("_usuario"));

                    self.setUser(usuario);
                    self.getUser();

                    return true;
                } catch(err) {
                    console.log("checkLogin() error parse", err);
                    return false;
                }
            }
        },
        logout: function() {
            var self = this;
            $(".mm-menu").hide();
            $("#mm-blocker").hide();            
        	loading.show();
        	window.localStorage.clear();
            // self.go("Introducao");
            // setTimeout(function() {

        	    location.reload();
            // }, 1000);
        },
        back: function() {
            var self = this;
            console.log("back()", self, window.history.length);
            if (window.history.length > 3) {
                // $(".content-load .dashboard-container").fadeOut(100);                
            }

            // if (self.$route.meta.auth == false) {
            //     window.history.go(-3);
            // } else {
                window.history.back();
            // }

        },
        fixClass: function() {
            var self = this;
            if (self.$route) {
                $("body").attr("class", "");
                $("body").addClass("current-page-" + self.$route.name.toLowerCase());            
            }
        },
        openModal: function(nome) {
            var self        = this;

            console.log("openModal()", nome)

            // loading.show();

            self.modal[nome]   = new tingle.modal({
                footer:         false,
                stickyFooter:   false,
                closeMethods:   ['overlay', '', 'escape'],
                closeLabel:     "",
                cssClass:       [(nome), "modal-default"]
            });   

            setTimeout(function() {
                self.modal[nome].setContent(document.querySelector('#' + nome).innerHTML);      
                self.modal[nome].open();
                // loading.hide();
                setTimeout(function() {
                    $("." + nome).append('<a class="close" onclick=\'window.__app.modal["' + nome + '"].close();\'><i><ion-icon name="close-outline"></ion-icon></i></a>');    
                }, 100);
            }, 500);
        },        
    },
    created: function() {
    	var self = this;
        self.initialize();  
        loading.show();
    },
    mounted: function() {
        console.log("mounted geral >>");
        var self = this;
        setTimeout(function() {
            $("#wrapper").fadeIn(1000);
            window.mmenuInit();
        }, 1000);
    },
	watch:{
        "sidebarToggleStatus": {
            immediate: true,
            deep: true,           
            handler: function(val) {
                var self = this;
                self.changeSidebarToggle();
            }
        },
	    $route (to, from){
	        var self = this;

            self.fixClass();
	        setTimeout(function() {
                window.mmenuInit();
                window.scrollTo({
                    top: 0
                });
            
	        }, 100);
	    }
	},
    on: {
    }      	
})



// WEBPACK FOOTER //
// ./src/main.js